<template>
  <v-dialog v-model="dialog" persistent max-width="1000">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" outlined :color="color" class="ml-3">
        <v-icon>{{ icon }}</v-icon
        ><span v-if="edit === false">Cadastrar Indicadores</span>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="modal-header elevation-10">
        <v-row>
          <v-col>
            <slot name="title"></slot>
          </v-col>
          <v-col class="text-right">
            <v-icon @click="dialog = false" color="white"
              >mdi-window-close</v-icon
            >
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col sm="3">
            <v-text-field
              label="Nome Indicador"
              name="nome"
              type="text"
              required
              v-model="payload.nomeindicador"
            ></v-text-field>
          </v-col>
          <v-col sm="3">
            <v-text-field
              label="Objeto"
              name="objeto"
              type="text"
              required
              v-model="payload.objeto"
            ></v-text-field>
          </v-col>
          <v-col sm="3">
            <v-select
              id="niveis-select"
              v-model="payload.salaIndicadorNivelId"
              item-text="nomeNivel"
              item-value="salaIndicadorNivelId"
              item-name="salaIndicadorNivelId"
              :items="niveis"
              label="Nível"
              placeholder="Nível"
            >
              <template slot="no-data">
                Nenhum nível
              </template>
            </v-select>
          </v-col>
          <v-col sm="3">
            <v-select
              id="temas-select"
              v-model="payload.salaIndicadorApuracaoId"
              item-text="nomeApuracao"
              item-value="salaIndicadorApuracaoId"
              item-name="salaIndicadorApuracaoId"
              :items="apuracao"
              label="Apuração"
              placeholder="Apuração"
            >
              <template slot="no-data">
                Nenhuma forma de apuração retornada
              </template>
            </v-select>
          </v-col>
          <v-col sm="3">
            <v-select
              id="temas-select"
              v-model="payload.salaIndicadorLeituraId"
              item-text="nomeLeitura"
              item-value="salaIndicadorLeituraId"
              item-name="salaIndicadorLeituraId"
              :items="leitura"
              label="Leitura"
              placeholder="Leitura"
            >
              <template slot="no-data">
                Nenhuma leitura retornada
              </template>
            </v-select>
          </v-col>
          <v-col sm="3">
            <v-select
              id="temas-select"
              v-model="payload.salaIndicadorFonteId"
              item-text="nomeFonte"
              item-value="salaIndicadorFonteId"
              item-name="salaIndicadorFonteId"
              :items="fonte"
              label="Fonte"
              placeholder="Fonte"
            >
              <template slot="no-data">
                Nenhuma fonte retornada
              </template>
            </v-select>
          </v-col>
          <v-col sm="3">
            <v-select
              id="temas-select"
              v-model="payload.salaIndicadorUnidadeId"
              item-text="nomeUnidade"
              item-value="salaIndicadorUnidadeId"
              item-name="salaIndicadorUnidadeId"
              :items="unidade"
              label="Unidade"
              placeholder="Unidade"
            >
              <template slot="no-data">
                Nenhuma unidade retornada
              </template>
            </v-select>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="error" outlined text @click="dialog = false"
          >Fechar</v-btn
        >
        <v-btn color="info" outlined text @click="onConfirm">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { salaIndicadoresApi } from '../API/SalaIndicadoresApi'
import { mapActions } from 'vuex'

export default {
  name: 'AppModalInsertUr',
  props: {
    object: { type: Object, required: false },
    edit: { type: Boolean, required: false, default: false },
    icon: { type: String, required: true },
    color: { type: String, required: true }
  },
  components: {},
  data () {
    return {
      payload: {
        salaIndicadorNivelId: 0,
        salaIndicadorApuracaoId: 0,
        salaIndicadorLeituraId: 0,
        salaIndicadorFonteId: 0,
        salaIndicadorUnidadeId: 0
      },
      niveis: [],
      apuracao: [],
      leitura: [],
      fonte: [],
      unidade: [],
      dialog: false
    }
  },
  mounted () {
    this.loadNiveis()
    this.loadApuracao()
    this.loadLeitura()
    this.loadFonte()
    this.loadUnidade()
    if (this.object && this.edit === true) {
      this.payload = this.object
    }
  },
  methods: {
    ...mapActions([
      'setLoading',
      'setConsultorCondutorMunicipio',
      'setLoading',
      'setAnalistaMunicipio',
      'setADMunicipio'
    ]),
    onConfirm () {
      if (this.edit === true) {
        salaIndicadoresApi
          .update(this.payload)
          .then(resp => {
            this.dialog = false
            this.$emit('on-save')
            location.reload()
          })
          .catch()
      } else {
        salaIndicadoresApi
          .create(this.payload)
          .then(resp => {
            this.dialog = false
            this.$emit('on-save')
            location.reload()
          })
          .catch()
      }
    },
    loadNiveis () {
      this.setLoading(true)
      salaIndicadoresApi
        .listNiveis()
        .then(resp => {
          this.niveis = resp.data
          this.setLoading(false)
        })
        .catch(resp => {
          this.setLoading(false)
          this.$notification.error('Erro ao obter URs')
        })
    },
    loadApuracao () {
      this.setLoading(true)
      salaIndicadoresApi
        .listApuracao()
        .then(resp => {
          this.apuracao = resp.data
          this.setLoading(false)
        })
        .catch(resp => {
          this.setLoading(false)
          this.$notification.error('Erro ao obter URs')
        })
    },
    loadFonte () {
      this.setLoading(true)
      salaIndicadoresApi
        .listFonte()
        .then(resp => {
          this.fonte = resp.data
          this.setLoading(false)
        })
        .catch(resp => {
          this.setLoading(false)
          this.$notification.error('Erro ao obter URs')
        })
    },
    loadLeitura () {
      this.setLoading(true)
      salaIndicadoresApi
        .listLeitura()
        .then(resp => {
          this.leitura = resp.data
          this.setLoading(false)
        })
        .catch(resp => {
          this.setLoading(false)
          this.$notification.error('Erro ao obter URs')
        })
    },
    loadUnidade () {
      this.setLoading(true)
      salaIndicadoresApi
        .listUnidade()
        .then(resp => {
          this.unidade = resp.data
          this.setLoading(false)
        })
        .catch(resp => {
          this.setLoading(false)
          this.$notification.error('Erro ao obter URs')
        })
    }
  }
}
</script>
